import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '~/app/core/services';

@Component({
  selector: 'app-reference-box',
  templateUrl: './reference-box.component.html',
  styleUrls: ['./reference-box.component.scss']
})
export class ReferenceBoxComponent implements OnInit {
  @Input() config: any;

  panelOpenState = true;

  constructor(public commonService: CommonService) { }

  ngOnInit(): void {
  }

  onShowFile(url, index): void {
    if (url) {
      this.commonService.processFile(url, { isDownload: false, index });
    }
  }
}
